import React, { useState, useEffect, useRef } from "react";
import "../styles/HotSpot.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faMinus } from "@fortawesome/free-solid-svg-icons";

export default function HotSpot({ HotSpotData }) {
  const [isHotSpotOpen, setisHotSpotOpen] = useState(false);

  const handleHotSpotCard = (e) => {
    setisHotSpotOpen(!isHotSpotOpen);
  };

  const HotSpotLocation = {
    top: HotSpotData.y,
    left: HotSpotData.x,
  };

  let buttonRef = useRef();

  useEffect(() => {
    let handler = (e) => {
      if (isHotSpotOpen === true && !buttonRef.current.contains(e.target)) {
        setisHotSpotOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [isHotSpotOpen]);

  return (
    <div style={HotSpotLocation} className="button-card absolute">
      <div className=" " ref={buttonRef}>
        {isHotSpotOpen === true ? (
          <div className="flex">
            <FontAwesomeIcon
              icon={faMinus}
              onClick={handleHotSpotCard}
              className="form-icon-minus"
            />
          </div>
        ) : (
          <div className="flex   ">
            <FontAwesomeIcon
              icon={faPlus}
              onClick={handleHotSpotCard}
              className="form-icon-plus"
            />
          </div>
        )}

        <div className="h-2/3 ">
          {isHotSpotOpen === true ? (
            <div className="relative button-window ">
              <div
                dangerouslySetInnerHTML={{
                  __html: HotSpotData.data,
                }}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}
